import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  Home, 
  MessageSquare, 
  CreditCard, 
  User, 
  ShieldCheck, 
  X 
} from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { Button } from '../ui/Button';

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const location = useLocation();
  const { isAdmin } = useAuth();
  
  const navItems = [
    {
      name: 'Home',
      path: '/',
      icon: <Home className="h-5 w-5" />,
      exact: true
    },
    {
      name: 'AI Humanizer',
      path: '/app',
      icon: <MessageSquare className="h-5 w-5" />,
      exact: false
    },
    {
      name: 'Profile',
      path: '/profile',
      icon: <User className="h-5 w-5" />,
      exact: false
    },
    {
      name: 'Buy Credits',
      path: '/payment',
      icon: <CreditCard className="h-5 w-5" />,
      exact: false
    }
  ];
  
  // Add admin link if user is admin
  const allNavItems = isAdmin ? [
    ...navItems,
    {
      name: 'Admin',
      path: '/admin',
      icon: <ShieldCheck className="h-5 w-5" />,
      exact: false
    }
  ] : navItems;
  
  return (
    <>
      {/* Mobile overlay */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-20 md:hidden"
          onClick={toggleSidebar}
        ></div>
      )}
      
      {/* Sidebar */}
      <aside 
        className={`
          fixed top-0 left-0 h-full bg-card border-r border-border w-64 z-30 transform transition-transform duration-300 ease-in-out
          ${isOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'}
        `}
      >
        <div className="flex flex-col h-full">
          {/* Sidebar header with logo */}
          <div className="flex items-center justify-between p-4 border-b border-border">
            <div className="flex items-center gap-2">
              <img src={process.env.PUBLIC_URL + "/thataihumanizer.svg"} alt="Logo" className="h-8 w-8" />
              <span className="font-bold text-lg text-primary">ThatAIHumanizer</span>
            </div>
            <Button 
              variant="ghost" 
              size="icon" 
              className="md:hidden" 
              onClick={toggleSidebar}
            >
              <X className="h-5 w-5" />
            </Button>
          </div>
          
          {/* Navigation links */}
          <nav className="flex-1 overflow-y-auto py-4">
            <ul className="space-y-1 px-2">
              {allNavItems.map((item) => {
                const isActive = item.exact 
                  ? location.pathname === item.path
                  : location.pathname.startsWith(item.path);
                  
                return (
                  <li key={item.path}>
                    <Link
                      to={item.path}
                      className={`
                        flex items-center gap-3 px-3 py-2 rounded-md transition-colors
                        ${isActive 
                          ? 'bg-primary/10 text-primary' 
                          : 'text-muted-foreground hover:bg-accent hover:text-foreground'}
                      `}
                      onClick={() => {
                        if (window.innerWidth < 768) {
                          toggleSidebar();
                        }
                      }}
                    >
                      {item.icon}
                      <span>{item.name}</span>
                    </Link>
                  </li>
                );
              })}
            </ul>
          </nav>
          
          {/* Footer */}
          <div className="p-4 border-t border-border">
            <div className="text-xs text-muted-foreground text-center">
              © {new Date().getFullYear()} ThatAIHumanizer
            </div>
          </div>
        </div>
      </aside>
    </>
  );
};

export default Sidebar; 